import InlineMessage from '3-components/InlineMessage/InlineMessage';
import { useDonorData } from '../libs/useDonorData';
// import BamboraPayment from '../BamboraPayment';
import PayfurlPayment from '../PayfurPayment';
import { PAYMENT } from '../libs/common';
import CheckoutPaymentIcons from './CheckoutPaymentIcons';
import { cn } from 'utils/className';
import DebitForm from '../DebitPayment';
import { useDonorBlockProps } from '../DonorDetailProvider';
import Icon from '2-core-elements/Icon/Icon';

export const PaymentForm = (): JSX.Element => {
    const { donorData: { payment } } = useDonorData();
    const { paymentPageIntro, paymentStepTitle, paymentStepSubtitle } = useDonorBlockProps();

    if (!payment) {
        return (
            <div>
                <InlineMessage status="error">
                    No payment selected. Please reload the page.
                </InlineMessage>
            </div>
        );
    }

    const containerClass = 'donor-payment-wrapper';
    const paymentContainerClass = payment ? `is-payment-${payment}` : '';
    const isEmptyContentHeader = !paymentStepTitle && !paymentStepSubtitle;

    return (
        <div className={cn(containerClass, paymentContainerClass)}>
            {!isEmptyContentHeader && (
                <div className="donor-payment-intro">
                    {paymentStepTitle && (
                        <div className="donor-payment-intro-title">
                            {paymentStepTitle}
                        </div>
                    )}
                    {paymentStepSubtitle && (
                        <div className="donor-payment-intro-description">
                            <div className="icon-box"><Icon icon={'lock-filled'} /></div>
                            <div className="intro-blurb">{paymentStepSubtitle}</div>
                        </div>
                    )}
                </div>
            )}
            <div className="donor-payment-header">
                <CheckoutPaymentIcons />
                {paymentPageIntro && (
                    <div className="donor-payment-header-text">
                        {paymentPageIntro}
                    </div>
                )}
            </div>
            <div className="donor-payment-iframe-wrapper">
                {payment === PAYMENT.CREDIT_CARD && (
                    <PayfurlPayment />
                )}

                {payment === PAYMENT.DIRECT_DEBIT && (
                    <DebitForm />
                )}
            </div>
        </div>
    );
};
